import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import VehiclesDTO from '../../../dto/VehiclesDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { createClearObject } from '../../../utils/utils';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadZoneList } from '../../Zones/actions';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import {
  PROPULSION_TYPES_LIST, VEHICLE_ENTITY_TYPES_LIST, VEHICLE_STATE_LIST,
} from '../../../configs';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import SelectGeographies from '../../Rules/components/SelectGeographies';
import { loadGeographyList } from '../../Geography/actions';
import { loadProviderList } from '../../Provider/actions';

export default function FilterForm(props) {
  const {
    onHide, getValues, reset, defaultValues, setValue, control,
  } = props;
  const { formatMessage } = useIntl();
  const DTO = new VehiclesDTO();
  const attributes = DTO.getAttributesByName();
  const clear = () => {
    const fields = getValues();
    const cleared = createClearObject(fields);
    reset({ ...cleared, ...defaultValues });
  };
  const save = () => {
    onHide();
  };

  return (
    <Dialog
      className={classNames('full-filter')}
      onClose={save}
      open
    >
      <DialogTitle header={formatMessage({ id: 'filters' })} title={<Icons onClick={onHide} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content custom-scroll-theme">
        <form className="filter-content-wrapper">
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.vehicle_id}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.device_id}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
          />
          {/* <FieldDTO */}
          {/*  control={control} */}
          {/*  component={CustomSelectInput} */}
          {/*  dtoObject={attributes.provider_id} */}
          {/*  withLabel */}
          {/*  variant="material" */}
          {/*  options={PROVIDER_LIST} */}
          {/* /> */}
          <FieldDTOWithCol
            control={control}
            dtoObject={attributes.provider_id}
            usePortal
            component={CustomSelectInputWithHelper}
            portalClassName="executor-selector"
            loadAction={loadProviderList}
            optionFormatter={item => ({ value: item.id, name: item.name })}
            filterName="full_name"
            variant="material"
            withLabel
            className="mb-3"
            // multiple
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.vehicle_type}
            withLabel
            variant="material"
            options={VEHICLE_ENTITY_TYPES_LIST}
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.propulsion_types}
            withLabel
            variant="material"
            options={PROPULSION_TYPES_LIST}
          />
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.year}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.mfgr}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.model}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.state}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
            options={VEHICLE_STATE_LIST}
          />

        </form>
      </DialogContent>
      <DialogFooter className="hff-footer">
        {/* <div className="hff-footer-text">{formatMessage({ id: 'find' }, { count: meta.count })}</div> */}
        <div className="hff-footer-buttons hff-center">
          {/* <Button className="hff-clear-show" onClick={save}>{formatMessage({ id: 'show' })}</Button> */}
          <Button className="hff-clear-data" variant="secondary" onClick={clear}>{formatMessage({ id: 'clear.all' })}</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
